/** 五目並べ (15×15 / ちょうど5連 / Swap2)。 mixed-engine の serde 形。 */
export type Side = 'First' | 'Second';
export type Swap2Phase = 'OpeningThree' | 'FirstChoice' | 'ExtraTwo' | 'SecondChoice' | 'Main';
export type GomokuChoice = 'TakeBlack' | 'TakeWhite' | 'PlaceTwo';
export type GomokuMove = GomokuChoice | { Place: { row: number; col: number } };

export interface GomokuOutcome {
  /** 勝者の席。 石の色は winner_color で持つ。 */
  winner: Side | null;
  winner_color: Side | null;
  reason: 'Five' | 'BoardFull';
}

export interface GomokuState {
  /** 石の物理色 (First = 黒、 Second = 白)。 */
  board: (Side | null)[][];
  /** 次に操作する席。 開局中は同じ席が複数石を置く。 */
  side: Side;
  phase: Swap2Phase;
  black_seat: Side | null;
  stones: number;
  outcome: GomokuOutcome | null;
}

export const GOMOKU_SIZE = 15;

export function isPlace(move: GomokuMove): move is { Place: { row: number; col: number } } {
  return typeof move === 'object' && move != null && 'Place' in move;
}

export function legalKey(row: number, col: number): string {
  return `${row}-${col}`;
}

/** 次の石の色は、 操作する席ではなく石数で決まる。 */
export function stoneColor(stones: number): Side {
  return stones % 2 === 0 ? 'First' : 'Second';
}

/** 席から物理色へ。 Swap2 の選択前は色を割り当てない。 */
export function colorForSeat(state: GomokuState, seat: Side): Side | null {
  if (state.black_seat == null) return null;
  return state.black_seat === seat ? 'First' : 'Second';
}

export function colorLabel(color: Side): string {
  return color === 'First' ? '黒' : '白';
}

export function seatLabel(seat: Side): string {
  return seat === 'First' ? '仮先' : '仮後';
}
